<template>
    <div id="app" class="site-wrapper" v-if="startRender">
        <portal-target name="selectorModal" />
        <preloader />
        
        <el-header class="site-header" height="auto">
            <div class="site-header__panel">
                <div class="site-header__inner">
                    <div class="site-header__item">
                        <site-dropdown :site-list="[{
                                id: 1,
                                link: '#',
                                title: 'Минтруд России',
                                description: 'Министерство труда и&nbsp;социальной <br /> защиты Российской Федерации',
                            },
                            {
                                id: 2,
                                link: '#',
                                title: 'Национальный совет',
                                description: 'Сайт Национального совета при Президенте Российской Федерации по&nbsp;профессиональным квалификациям',
                            },
                            {
                                id: 3,
                                link: '#',
                                title: 'Национальное агентство',
                                description: 'Реестр сведений о&nbsp;проведении независимой <br /> оценки квалификации',
                            },
                            {
                                id: 4,
                                link: '#',
                                title: 'Реестр',
                                description: 'Министерство труда и&nbsp;социальной <br /> защиты Российской Федерации',
                            },
                            {
                                id: 5,
                                link: '#',
                                title: 'ПМК &laquo;Разработка квалификаций&raquo;',
                                description: 'Программно-методический комплекс разработки <br /> профессиональных квалификаций',
                            }]"
                        />
                    </div>

                    <div class="site-header__item">
                        <ul class="extra-list">
                            <li class="extra-list__item">
                                Почта: <a href="mailto:dok@nark.ru" class="extra-list__link">dok@nark.ru</a>
                            </li>
                            <li class="extra-list__item">
                                Телефон: <a href="tel:+74959661695" class="extra-list__link">+7 (495) 966-16-95</a>
                            </li>
<!--                            <li class="extra-list__item">-->
<!--                                <a href="#" class="extra-list__link">Справочная информация</a>-->
<!--                            </li>-->
                        </ul>
                    </div>
                </div>
            </div>

            <div class="site-header__main">
                <div class="site-header__inner">
                    <div class="site-header__item">
                        <router-link to="/">
                            <img src="@/assets/img/logo.png" alt='Логотип "Национальное агентство развития квалификации"' class="site-header__logo">
                        </router-link>
                    </div>
                    
                    <div class="site-header__item">
                        <nav>
                            <ul class="site-nav">
                                <li class="site-nav__item">
                                    <router-link to="/career_trajectory" class="site-nav__link">
                                        <div class="site-nav__icon-wrap">
                                            <icon-base width="20" height="12" viewBox="0 0 20 12" class="site-nav__icon">
                                                <icon-career />
                                            </icon-base>
                                        </div>

                                        <span class="site-nav__label">Карьерные траектории</span>
                                    </router-link>
                                </li>
                                <!-- <li class="site-nav__item">
                                    <a href="#" class="site-nav__link">
                                        <div class="site-nav__icon-wrap">
                                            <icon-base width="20" height="20" viewBox="0 0 20 20" class="site-nav__icon">
                                                <icon-accept />
                                            </icon-base>
                                        </div>

                                        <span class="site-nav__label">Выбор СПК</span>
                                    </a>
                                </li> -->
                                <li class="site-nav__item">
                                    <router-link to="/documents" class="site-nav__link">
                                        <div class="site-nav__icon-wrap">
                                            <icon-base width="16" height="20" viewBox="0 0 16 20" class="site-nav__icon">
                                                <icon-doc />
                                            </icon-base>
                                        </div>

                                        <span class="site-nav__label">Документы</span>
                                    </router-link>
                                </li>
                                <li class="site-nav__item">
                                    <a class="site-nav__link" @click="elDialogs.help = true">
                                        <div class="site-nav__icon-wrap">
                                            <icon-base width="20" height="20" viewBox="0 0 20 20" class="site-nav__icon">
                                                <icon-faq />
                                            </icon-base>
                                        </div>

                                        <span class="site-nav__label">Помощь и&nbsp;запрос</span>
                                    </a>
                                </li>
                                <li class="site-nav__item">
                                    <a v-if="!accessToken" class="site-nav__link" @click="elDialogs.login = true">
                                        <div class="site-nav__icon-wrap">
                                            <icon-base width="20" height="20" viewBox="0 0 20 20" class="site-nav__icon">
                                                <icon-profile />
                                            </icon-base>
                                        </div>

                                        <span class="site-nav__label">Вход</span>
                                    </a>

                                    <selector-btn v-else :options="accordionProfileOptionsForBtn"  @clickOnItem="callback">
                                        <div class="user">
                                            <div class="user__link">
                                                <img :src="user.avatar ? user.avatar : 'https://via.placeholder.com/330x330'" alt="user_photo" class="user__avatar">
                                            </div>
                                        </div>
                                    </selector-btn>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </el-header>

        <!-- Dialogs -->

        <login-dialog />
        <reference-information-dialog />
        <help-dialog />
        <alert />
        <router-view />
        <cookie-widget />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import SiteDropdown from '@/components/SiteDropdown';
import Preloader from '@/components/Preloader';
import dialog from '@/mixins/dialog';
import Alert from '@/components/Alert';
import CookieWidget from '@/components/CookieWidget';
import SelectorBtn from '@/components/SelectorBtn';

import LoginDialog from '@/components/Dialogs/LoginDialog'
import ReferenceInformationDialog from '@/components/Dialogs/ReferenceInformationDialog'
import HelpDialog from '@/components/Dialogs/HelpDialog.vue';

export default {
    mixins: [ dialog ],
    components: {
        Preloader,
        SiteDropdown,
        LoginDialog,
        Alert,
        CookieWidget,
        SelectorBtn,
        ReferenceInformationDialog,
        HelpDialog
    },
    data() {
        return {
            startRender: false,
            accordionProfileOptionsForBtn: [
                {
                    name: 'Личный кабинет',
                    callback: 'gotoProfile'
                },
                {
                    name: 'Выйти',
                    warning: true,
                    callback: 'logout'
                }
            ]
        }
    },
    computed: {
        ...mapState('tokens', ['accessToken', 'accessTokenInitTime']),
        ...mapState('user', ['user']),
        ...mapState('loader', ['loading'])
    },
    methods: {
        ...mapActions('user', ['LOAD_USER']),
        ...mapActions('tokens', ['LOGOUT', 'UPDATE_TOKEN']),
        ...mapMutations('tokens', ['SET_ACCESS_TOKEN']),

        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },
        gotoProfile() {
            this.$router.push({ path: `/profile` }).catch(()=>{});
        },
        async logout() {
            await this.LOGOUT()
            this.$router.push({ path: `/` }).catch(()=>{});
        }
    },
    async mounted() {
        this.startRender = false

        const localStorageData = JSON.parse(localStorage.getItem('ork.nark'))
        if (localStorageData) {
            const limit = 20 * 3600 * 1000; // 24 часа
            const accessTokenInitTime = localStorageData.tokens.accessTokenInitTime

            if(+new Date() - accessTokenInitTime <= limit) {
                const accessToken = localStorageData.tokens.accessToken
                await this.SET_ACCESS_TOKEN(accessToken)
                // await this.UPDATE_TOKEN() TODO
                await this.LOAD_USER()
            } else {
                await this.SET_ACCESS_TOKEN('')
            }
        }

        this.startRender = true
    }
}
</script>
